cv.getBillingStatus = function(organization){
  var status = {
    exceeded_trial : false,
    card_on_file : false
  };

  if(organization.get('enable_trial_day') == 1){
    if(moment(cv.organization.get('trial_end') + ' Z').diff(moment()) < 0){
      status.exceeded_trial = true;
    }
  }else{
    if(parseInt(organization.get('trial_status'), 10) > parseInt(organization.get('trial_limit'), 10)){
      status.exceeded_trial = true;
    }
  }
  
  if(organization.get('last4') != ''){
    status.card_on_file = true;
  }

  // This is a HACK, force both to true if we have already paid
  if(organization.get('plan') == 'prepaid'){
    status.exceeded_trial = true;
    status.card_on_file = true;
  }

  console.log('Trial Status', status);

  return status;
};